// #468: a box's STABLE identity across re-materialize - the dominant (max-stems)
// line's variety identity (slug + length + color). Boxes get a fresh id on every
// materialize, so this content anchor is what lets #431's stable ORDER and the
// fill-communication SELECTED SIZE survive a re-pack. Shared so both read one key.
import type { CartBox } from "./types";

export function boxAnchorKey(box: CartBox): string {
  let best = box.contents[0];
  for (const l of box.contents) {
    if ((l.stems ?? 0) > (best?.stems ?? -1)) best = l;
  }
  return best
    ? `${best.slug}::${best.length ?? "-"}::${best.colorChoice ?? "-"}`
    : box.id;
}
